import Home from './views/Home'
import ArtistIndex from './views/ArtistIndex'
import ArtistDetail from './views/ArtistDetail'
import VenueIndex from './views/VenueIndex'
import VenueDetail from './views/VenueDetail'
import ProgrammeIndex from './views/ProgrammeIndex'
import ProgrammeDetail from './views/ProgrammeDetail'
import SavedIndex from './views/SavedIndex'


export const routes = [
  { path: '/', component: Home, name: 'home', props: {query:true} },
  { path: '/programme', name:'programmeIndex', component: ProgrammeIndex, props: (route) => ({ slug: route.params.slug}) },
  { path: '/saved', name:'savedIndex', component: SavedIndex },
  { path: '/programme/:slug', name:'programmeDetail', component: ProgrammeDetail, props: (route) => ({ slug: route.params.slug}) },
  { path: '/00/00', component: ArtistIndex, name: 'artistIndex', props: {query:true} },
  { path: '/99/00', name:'venueIndex', component: VenueIndex, props: (route) => ({ slug: route.params.slug}) },
  { path: '/99/:slug', name:'venueDetail', component: VenueDetail, props: (route) => ({ slug: route.params.slug}) },
  { path: '/:slug/:url', name:'artistDetail', component: ArtistDetail, props: (route) => ({ slug: route.params.slug, url: route.params.url}) },
]


// WEBPACK FOOTER //
// ./src/routes.js